module.exports = __webpack_public_path__ + "img/icon_book_que_1@4x.06fffd24.png";